import { Route, Routes } from 'react-router'
import { NewInboxAccessLayout } from 'pages/settings/pages/inboxes/pages/newInbox/layout/NewInboxAccessLayout'
import { NewInboxProviderLayout } from 'pages/settings/pages/inboxes/pages/newInbox/layout/NewInboxProviderLayout'
import { NewInboxStepsLayout } from 'pages/settings/pages/inboxes/pages/newInbox/layout/NewInboxStepsLayout'
import { GeneralInfo } from 'pages/settings/pages/inboxes/pages/newInbox/ui/GeneralInfo/GeneralInfo'
import { HowAddNumber } from 'pages/settings/pages/inboxes/pages/newInbox/ui/HowAddNumber/HowAddNumber'
import { AddSalesmsgNumbers } from 'pages/settings/pages/inboxes/pages/newInbox/ui/AddSalesmsgNumbers/AddSalesmsgNumbers'
import { Payment } from 'pages/settings/pages/inboxes/pages/newInbox/ui/Payment/Payment'
import { ChooseNumber } from 'pages/settings/pages/inboxes/pages/newInbox/ui/ChooseNumber/ChooseNumber'
import { SelectAppAndNumbers } from 'pages/settings/pages/inboxes/pages/newInbox/ui/SelectAppAndNumbers/SelectAppAndNumbers'
import { EnterNumber } from 'pages/settings/pages/inboxes/pages/newInbox/ui/EnterNumber/EnterNumber'
import { EnterAddress } from 'pages/settings/pages/inboxes/pages/newInbox/ui/EnterAddress/EnterAddress'
import { VerifyNumber } from 'pages/settings/pages/inboxes/pages/newInbox/ui/VerifyNumber/VerifyNumber'
import { AuthorizationDocument } from 'pages/settings/pages/inboxes/pages/newInbox/ui/AuthorizationDocument/AuthorizationDocument'
import { NewInboxRoutes } from './type'

export const NewInboxRouter = () => {
  return (
    <Routes>
      <Route element={<NewInboxAccessLayout />}>
        <Route element={<NewInboxProviderLayout />}>
          <Route path={NewInboxRoutes.steps} element={<NewInboxStepsLayout />}>
            <Route path={NewInboxRoutes.newInbox} element={<GeneralInfo />} />
            <Route path={NewInboxRoutes.howAddNumber} element={<HowAddNumber />} />
            <Route path={NewInboxRoutes.addSalesmsgNumbers} element={<AddSalesmsgNumbers />} />
            <Route path={NewInboxRoutes.payment} element={<Payment />} />
            <Route path={NewInboxRoutes.chooseNumber} element={<ChooseNumber />} />
            <Route path={NewInboxRoutes.selectAppAndNumbers} element={<SelectAppAndNumbers />} />
            <Route path={NewInboxRoutes.enterNumber} element={<EnterNumber />} />
            <Route path={NewInboxRoutes.enterAddress} element={<EnterAddress />} />
            <Route path={NewInboxRoutes.verifyNumber} element={<VerifyNumber />} />
            <Route
              path={NewInboxRoutes.authorizationDocument}
              element={<AuthorizationDocument />}
            />
          </Route>
        </Route>
      </Route>
    </Routes>
  )
}
